import Parser from "html-react-parser";

export default function NewsItem({ date, description, recKey, title, image }) {
  const parsedDescription = Parser(description, {
    replace(domNode) {
      if (domNode?.name !== "img" || !domNode.attribs) return undefined;
      const { src = "", alt = "" } = domNode.attribs;
      const normalizedSrc = src.startsWith("../api/")
        ? `https://friendsofstandrewsstatepark.org${src.slice(2)}`
        : src;

      return <img src={normalizedSrc} alt={alt || title} loading="lazy" />;
    },
  });

  return (
    <div className="card d-flex flex-column fsa-news-card mb-3">
      <div className="d-flex justify-content-between card-header fsa-card-header">
        <span className="d-flex fw-semibold">{title}</span>
        <span className="d-flex fsa-card-header-date">
          {new Date(
            new Date(date).setHours(new Date(date).getHours()),
          ).toLocaleString("en-US", {
            hour12: true,
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      </div>
      <div className="d-flex card-body flex-column flex-md-row">
        {image.length > 0 && (
          <span
            className="d-flex me-3 mb-3 mb-md-0 flex-shrink-0"
            style={{ width: "100%", maxWidth: 240 }}
          >
            <img
              className="d-block w-100 rounded"
              src={`https://friendsofstandrewsstatepark.org/api/files/news/${recKey}/${image}`}
              alt={title}
              loading="lazy"
            />
          </span>
        )}
        <div className="d-flex flex-grow-1 flex-column justify-content-center news-item-content">
          {parsedDescription}
        </div>
      </div>
    </div>
  );
}
